import { render } from "./AuthLiquidationDetails.vue?vue&type=template&id=3c27e6b7&scoped=true"
import script from "./AuthLiquidationDetails.vue?vue&type=script&lang=js"
export * from "./AuthLiquidationDetails.vue?vue&type=script&lang=js"

import "./AuthLiquidationDetails.vue?vue&type=style&index=0&id=3c27e6b7&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c27e6b7"]])

export default __exports__